/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFakProfileLookup.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/fak-profile-lookup";

export class AutogenModelFakProfileLookup<RowType extends ModelRow> extends Endpoint<RowType, RowFakProfileLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFakProfileLookup extends ModelRow<RowFakProfileLookupFields> {
	constructor(values?: Partial<RowFakProfileLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFakProfileLookupFields {
	company_id: string;
	description: string;
	id: string;
}

